import { AfishaBanner, BannerTargetType } from "../types/entities/banner"
import { hrefForCurrentCinema } from "./cinemaSlugs"

function resolveTargetType(banner: AfishaBanner): BannerTargetType {
    if (banner.target_type === "film" || banner.target_type === "action" || banner.target_type === "none") {
        return banner.target_type
    }
    if (typeof banner.film_id === "number" && banner.film_id > 0) return "film"
    if (typeof banner.action_id === "number" && banner.action_id > 0) return "action"
    return "none"
}

export function getBannerLink(banner: AfishaBanner): string | null {
    const type = resolveTargetType(banner)
    if (type === "film" && banner.film_id) return hrefForCurrentCinema(`/afisha/film/${banner.film_id}`)
    if (type === "action" && banner.action_id) return hrefForCurrentCinema(`/promo/${banner.action_id}`)
    return null
}

export function normalizeAfishaBanners(data: unknown): AfishaBanner[] {
    if (!Array.isArray(data)) return []

    return data
        .map((item): AfishaBanner | null => {
            if (!item || typeof item !== "object") return null
            const banner = item as AfishaBanner
            if (typeof banner.id !== "number" || typeof banner.image !== "string" || !banner.image) {
                return null
            }
            if (banner.show_on_site === false) return null

            const target_type = resolveTargetType(banner)
            return { ...banner, target_type }
        })
        .filter((item): item is AfishaBanner => item !== null)
        .sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0) || a.id - b.id)
}
